var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1581 21.7944C23.6224 21.7944 24 22.1769 24 22.6472C24 23.1184 23.6224 23.5 23.1581 23.5H18.3997C17.9355 23.5 17.5579 23.1184 17.5579 22.6472C17.5579 22.1769 17.9355 21.7944 18.3997 21.7944H23.1581ZM19.8582 9.08255L21.0874 10.059C21.5914 10.4531 21.9275 10.9727 22.0424 11.5192C22.1751 12.1202 22.0336 12.7106 21.6357 13.2212L14.3137 22.6899C13.9776 23.1199 13.4824 23.3618 12.9518 23.3707L10.0337 23.4066C9.87449 23.4066 9.74184 23.2991 9.70647 23.1468L9.04325 20.2712C8.92829 19.7427 9.04325 19.1963 9.37928 18.7752L14.5701 12.0566C14.6585 11.9491 14.8177 11.9321 14.9238 12.0119L17.108 13.7497C17.2495 13.8662 17.4441 13.9289 17.6475 13.902C18.0808 13.8483 18.3726 13.4541 18.3284 13.0331C18.3018 12.8181 18.1957 12.6389 18.0542 12.5045C18.01 12.4687 15.9319 10.8025 15.9319 10.8025C15.7993 10.695 15.7728 10.4979 15.8789 10.3645L16.7013 9.29755C17.4618 8.32111 18.7882 8.23153 19.8582 9.08255Z",
    fill: "#818181"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#D3D3D3",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.dc02d9bbba05e84d902218be5dea530d.svg";
export { ForwardRef as ReactComponent };